/**
 * Shared slider utilities
 * Used across tour and accommodation pages
 * Preserves all business logic exactly
 */

import { handleImageUrl } from '../helpers';

export const createSliderSettings = (customPagingFn) => {
    return {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        customPaging: customPagingFn
    };
};

export const processImageString = (imageString) => {
    if (!imageString) return [];
    
    let images = imageString.split(',');
    images.pop(); // Remove trailing empty string
    return images.filter(img => img); // Filter out empty strings
};

export const createSliderImages = (imageString, altText) => {
    const images = processImageString(imageString);
    
    return images.map((img, idx) => {
        return (
            <div key={idx} className='slider-image-wrapper'>
                <img src={handleImageUrl(img)} alt={altText || 'Image'} />
            </div>
        );
    });
};

export const updateSliderSettingsWithImages = (baseSettings, images) => {
    return {
        ...baseSettings,
        customPaging: (i) => {
            return (
                <div style={{ backgroundImage: `url(${handleImageUrl(images[i])})` }}></div>
            );
        }
    };
};
